var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 108,
    viewBox: "0 0 95 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_459_466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 4.33013C44.641 1.65063 50.359 1.65063 55 4.33013L74.208 15.4199C78.849 18.0994 81.708 23.0513 81.708 28.4103V50.5897C81.708 55.9487 78.849 60.9006 74.208 63.5801L55 74.6699C50.359 77.3494 44.641 77.3494 40 74.6699L20.792 63.5801C16.151 60.9006 13.292 55.9487 13.292 50.5897V28.4103C13.292 23.0513 16.151 18.0994 20.792 15.4199L40 4.33013Z",
    fill: "#05C6C5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 32.1204C43 31.1492 43 30.6636 43.2025 30.396C43.3789 30.1628 43.6485 30.0185 43.9404 30.001C44.2754 29.981 44.6795 30.2504 45.4875 30.7891L56.0031 37.7995C56.6708 38.2446 57.0046 38.4672 57.1209 38.7477C57.2227 38.9929 57.2227 39.2686 57.1209 39.5138C57.0046 39.7943 56.6708 40.0169 56.0031 40.462L45.4875 47.4724C44.6795 48.0111 44.2754 48.2805 43.9404 48.2604C43.6485 48.243 43.3789 48.0987 43.2025 47.8655C43 47.5979 43 47.1123 43 46.1411V32.1204Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_459_466",
    x: 0.291992,
    y: 2.3205,
    width: 94.416,
    height: 105.359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.776471 0 0 0 0 0.772549 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_466",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.82ed8198b500acb490c7b9fc696e67bf.svg";
export { ForwardRef as ReactComponent };